// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DrrpDataextracttaskmgrIconOutlinedSvg from "@fishx/icons-svg/es/asn/DrrpDataextracttaskmgrIconOutlined";
import FishxIcon from '../components/FishxIcon';

var DrrpDataextracttaskmgrIconOutlined = function DrrpDataextracttaskmgrIconOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DrrpDataextracttaskmgrIconOutlinedSvg
  }));
};

DrrpDataextracttaskmgrIconOutlined.displayName = 'DrrpDataextracttaskmgrIconOutlined';
export default React.forwardRef(DrrpDataextracttaskmgrIconOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DrrpDataextracttaskmgrIconOutlined.js
// module id = 2539
// module chunks = 0